module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.id
    }
  }, [_c('button', {
    staticClass: "addPlanoToBasket",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.openModalAddPlanoToBasket($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon",
    class: _vm.status
  }, [_c('i', {
    staticClass: "fas fa-shopping-basket fa-1x"
  })]), _vm._v(" " + _vm._s(_vm.$trad.basket.addBasketToPlano) + "\n    ")]), _vm._v(" "), (_vm.displayBasket && _vm.dataAction.idPlano === _vm.item.id) ? _c('ModalBasket', {
    attrs: {
      "action": _vm.dataAction
    },
    on: {
      "hideBasketModal": _vm.close
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7335c7a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planoList/components/add-to-basket.vue
// module id = 3268
// module chunks = 0